import gql from 'graphql-tag';

export const allCostSharing = gql`
  query findAllCostSharings {
    findAllCostSharings {
      code
      status
      data {
        id
        name
        code
        description
        subGroups {
          id
          name
          code
          costSharingName
        }
      }
    }
  }
`;

export const facilityCostSharing = gql`
  query getFacilityCostSharingGroups {
    getFacilityCostSharingGroups {
      code
      status
      data {
        id
        name
        subGroups {
          id
          name
          services {
            itemId
            itemName
            price
            gfsCode
            isPayable
            directCharge
          }
        }
      }
    }
  }
`;

export const saveFacility = gql`
  mutation saveFacilityCostSharingGroup(
    $input: FacilityCostSharingGroupDtoInput
  ) {
    saveFacilityCostSharingGroup(entityDto: $input) {
      code
      status
      data {
        costSharingGroup {
          costSharing {
            description
          }
          id
        }
        facilityCode
      }
    }
  }
`;

export const pageCostSharingGroups = gql`
  query pageCostSharingGroups {
    pageCostSharingGroups(size: 100, page: 0) {
      code
      status
      data {
        id
        code
        name
        costSharingName
        costSharingCode
        costSharingId
        active
        deleted
      }
    }
  }
`;

export const saveCostSharingGroup = gql`
  mutation saveCostSharingGroup($input: CostSharingGroupDtoInput) {
    saveCostSharingGroup(entityDto: $input) {
      code
      status
      data {
        id
        description
        name
      }
    }
  }
`;

export const saveCostSharing = gql`
  mutation saveCostSharing($input: CostSharingDtoInput) {
    saveCostSharing(entityDto: $input) {
      code
      status
      data {
        id
        name
        code
        deleted
        active
      }
    }
  }
`;

export const facilityEntryService = gql`
  mutation saveFacilityEntryService($input: FacilityEntryServiceDtoInput!) {
    saveFacilityEntryService(entityDto: $input) {
      code
      status
      data {
        id
        item {
          id
          name
        }
      }
    }
  }
`;
